import { render } from "./ChipInput.vue?vue&type=template&id=0cd796a7&scoped=true"
import script from "./ChipInput.vue?vue&type=script&lang=js"
export * from "./ChipInput.vue?vue&type=script&lang=js"

import "./ChipInput.vue?vue&type=style&index=0&id=0cd796a7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd796a7"]])

export default __exports__